export default {
    route: {
        home: '首頁',

        pms: '商品管理',
        product: '商品列表',
        addProduct: '添加商品',
        updateProduct: '修改商品',
        productRecycle: '商品回收站',
        productComment: '商品評價',
        productCate: '商品分類',
        addProductCate: '添加商品分類',
        updateProductCate: '修改商品分類',
        productAttr: '商品類型',
        productAttrList: '商品屬性列表',
        addProductAttr: '添加商品屬性',
        updateProductAttr: '修改商品屬性',
        brand: '品牌管理',
        addBrand: '添加品牌',
        updateBrand: '編輯品牌',

        crm: '會員管理',
        member: '會員列表',
        memberLevel: '會員等級',

        oms: '訂單管理',
        order: '訂單列表',
        orderDetail: '訂單詳情',
        deliverOrderList: '發貨列表',
        orderSetting: '訂單設置',
        returnApply: '退貨申請處理',
        returnReason: '退貨原因設置',
        returnApplyDetail: '退貨原因詳情',

        mms: '商家管理',
        shop: '商家列表',
        addShop: '新增商家',
        updateShop: '修改商家',
        withdraw: '提現申請',

        cms: '資訊文章',
        article: '文章列表',
        addArticle: '新增文章',

        sys: '系統配置',
        params: '系統參數',
        permission: '權限管理',

        vms: '視頻',
        video: '視頻列表',
        videoLivePlan: '直播計劃列表',
        addVideoLivePlan: '添加直播計劃',
        updateVideoLivePlan: '編輯直播計劃',



        documentation: '文檔',
        guide: '引導頁',
        // permission: '權限測試頁',
        rolePermission: '角色權限',
        pagePermission: '頁面權限',
        directivePermission: '指令權限',
        icons: '圖標',
        components: '組件',
        tinymce: '富文本編輯器',
        markdown: 'Markdown',
        jsonEditor: 'JSON 編輯器',
        dndList: '列表拖拽',
        splitPane: 'Splitpane',
        avatarUpload: '頭像上傳',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'Count To',
        componentMixin: '小組件',
        backToTop: '返回頂部',
        dragDialog: '拖拽 Dialog',
        dragSelect: '拖拽 Select',
        dragKanban: '可拖拽看板',
        charts: '圖表',
        keyboardChart: '鍵盤圖表',
        lineChart: '折線圖',
        mixChart: '混合圖表',
        example: '綜合實例',
        nested: '路由嵌套',
        menu1: '菜單1',
        'menu1-1': '菜單 1-1',
        'menu1-2': '菜單 1-2',
        'menu1-2-1': '菜單 1-2-1',
        'menu1-2-2': '菜單 1-2-2',
        'menu1-3': '菜單 1-3',
        menu2: '菜單 2',
        Table: 'Table',
        dynamicTable: '動態 Table',
        dragTable: '拖拽 Table',
        inlineEditTable: 'Table 內編輯',
        complexTable: '綜合 Table',
        tab: 'Tab',
        form: '表單',
        createArticle: '創建文章',
        editArticle: '編輯文章',
        articleList: '文章列表',
        errorPages: '錯誤頁面',
        page401: '401',
        page404: '404',
        errorLog: '錯誤日誌',
        excel: 'Excel',
        exportExcel: '導出 Excel',
        selectExcel: '導出 已選擇項',
        mergeHeader: '導出 多級表頭',
        uploadExcel: '上傳 Excel',
        zip: 'Zip',
        pdf: 'PDF',
        exportZip: 'Export Zip',
        theme: '換膚',
        clipboardDemo: 'Clipboard',
        i18n: '國際化',
        externalLink: '外鏈',
        profile: '個人中心'
    },
    navbar: {
        dashboard: '首頁',
        github: '項目地址',
        logOut: '退出登錄',
        profile: '個人中心',
        theme: '換膚',
        size: '布局大小'
    },
    login: {
        title: '系統登錄',
        logIn: '登錄',
        username: '賬號',
        password: '密碼',
        any: '隨便填',
        thirdparty: '第三方登錄',
        thirdpartyTips: '本地不能模擬，請結合自己業務進行模擬！！！'
    },
    documentation: {
        documentation: '文檔',
        github: 'Github 地址'
    },
    permission: {
        addRole: '新增角色',
        editPermission: '編輯權限',
        roles: '妳的權限',
        switchRoles: '切換權限',
        tips: '在某些情況下，不適合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它動態渲染 dom 的場景。妳只能通過手動設置 v-if 來實現。',
        delete: '刪除',
        confirm: '確定',
        cancel: '取消'
    },
    guide: {
        description: '引導頁對於壹些第壹次進入項目的人很有用，妳可以簡單介紹下項目的功能。本 Demo 是基於',
        button: '打開引導'
    },
    components: {
        documentation: '文檔',
        tinymceTips: '富文本是管理後臺壹個核心的功能，但同時又是壹個有很多坑的地方。在選擇富文本的過程中我也走了不少的彎路，市面上常見的富文本都基本用過了，最終權衡了壹下選擇了Tinymce。更詳細的富文本比較和介紹見',
        dropzoneTips: '由於我司業務有特殊需求，而且要傳七牛 所以沒用第三方，選擇了自己封裝。代碼非常的簡單，具體代碼妳可以在這裏看到 @/components/Dropzone',
        stickyTips: '當頁面滾動到預設的位置會吸附在頂部',
        backToTopTips1: '頁面滾動到指定位置會在右下角出現返回頂部按鈕',
        backToTopTips2: '可自定義按鈕的樣式、show/hide、出現的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素',
        imageUploadTips: '由於我在使用時它只有vue@1版本，而且和mockjs不兼容，所以自己改造了壹下，如果大家要使用的話，優先還是使用官方版本。'
    },
    table: {
        dynamicTips1: '固定表頭, 按照表頭順序排序',
        dynamicTips2: '不固定表頭, 按照點擊順序排序',
        dragTips1: '默認順序',
        dragTips2: '拖拽後順序',
        title: '標題',
        importance: '重要性',
        type: '類型',
        remark: '點評',
        search: '搜索',
        add: '添加',
        export: '導出',
        reviewer: '審核人',
        id: '序號',
        date: '時間',
        author: '作者',
        readings: '閱讀數',
        status: '狀態',
        actions: '操作',
        edit: '編輯',
        publish: '發布',
        draft: '草稿',
        delete: '刪除',
        cancel: '取 消',
        confirm: '確 定'
    },
    example: {
        warning: '創建和編輯頁面是不能被 keep-alive 緩存的，因為keep-alive 的 include 目前不支持根據路由來緩存，所以目前都是基於 component name 來進行緩存的。如果妳想類似的實現緩存效果，可以使用 localStorage 等瀏覽器緩存方案。或者不要使用 keep-alive 的 include，直接緩存所有頁面。詳情見'
    },
    errorLog: {
        tips: '請點擊右上角bug小圖標',
        description: '現在的管理後臺基本都是spa的形式了，它增強了用戶體驗，但同時也會增加頁面出問題的可能性，可能壹個小小的疏忽就導致整個頁面的死鎖。好在 Vue 官網提供了壹個方法來捕獲處理異常，妳可以在其中進行錯誤處理或者異常上報。',
        documentation: '文檔介紹'
    },
    excel: {
        export: '導出',
        selectedExport: '導出已選擇項',
        placeholder: '請輸入文件名(默認excel-list)'
    },
    zip: {
        export: '導出',
        placeholder: '請輸入文件名(默認file)'
    },
    pdf: {
        tips: '這裏使用   window.print() 來實現下載pdf的功能'
    },
    theme: {
        change: '換膚',
        documentation: '換膚文檔',
        tips: 'Tips: 它區別於 navbar 上的 theme-pick, 是兩種不同的換膚方法，各自有不同的應用場景，具體請參考文檔。'
    },
    tagsView: {
        refresh: '刷新',
        close: '關閉',
        closeOthers: '關閉其它',
        closeAll: '關閉所有'
    },
    settings: {
        title: '系統布局配置',
        theme: '主題色',
        tagsView: '開啟 Tags-View',
        fixedHeader: '固定 Header',
        sidebarLogo: '側邊欄 Logo'
    },


    //----------------------------------------------------hungkin国际化----------------------------------------------------------------------

    base:{
        add:'添加',
        delete:'刪除',
        edit:'編輯',
        batchOperate:'批量操作',
        prompt:'提示',
        define:'確定',
        cancel:'取消',
        wideDefine:'確 定',
        wideCancel:'取 消',
        search:{
            searchTitle: '篩選搜索',
            searchBtn: '查詢搜索',
            resetBtn: '重置',
        },
        isBatchText:'是否要進行該批量操作？',
        isEditText:'是否要進行修改？',
        editSuccess:'修改成功',
        noSkuInfo:'暫無sku信息',
        selectOperatesPrdText:'請選擇要操作的商品',
        selectOperatesType:'請選擇操作類型',
    },

    product: {
        list: {
            searchTitle: '篩選搜索',
            searchBtn: '查詢搜索',
            resetBtn: '重置',
            keyword: '輸入搜索',
            productCode: '商品貨號',
            categories: '商品分類',
            selectCategories: '請選擇商品分類',
            productBrand: '商品品牌',
            selectBrand: '請選擇品牌',
            shelfStatus: '上架狀態',
            approvalStatus: '審核狀態',
            price: '價格',
            itemNo: '貨號',
            putOnTheShelf: '上架',
            newProduct: '新品',
            recommend: '推薦',
            table: {
                datasheets: '數據列表',
                serialNumber: '編號',
                productPic: '商品圖片',
                brand: '品牌',
                productName: '商品名稱',
                shopName: '商家名稱',
                priceItemNumber: '價格/貨號',
                tag: '標籤',
                skuInventory: 'SKU庫存',
                sales: '銷量',
                createTime: '創建時間',
                approvalStatus: '審核狀態',
                operate: '操作',
            },
            editPrdInfo: '編輯貨品信息',
            searchText: '按sku編號搜索',
            skuNumber: 'SKU編號',
            sellingPrice: '銷售價格',
            commodityStocks: '商品庫存',
            inventoryWarning: '庫存預警值',
            lengthCm: '長cm',
            widthCm: '寬cm',
            heightCm: '高cm',
            volume: '體積cm³',
            weight: '重量（克）',
            sort: '排序',
            batchOperates:{
                publishOn:'商品上架',
                publishOff:'商品下架',
                recommendOn:'設為推薦',
                recommendOff:'取消推薦',
                newOn:'設為新品',
                newOff:'取消新品',
                verifyOn:'審核通過',
                verifyOff:'取消審核',
            },
            publishStatusOptions:{
                publishOn:'上架',
                publishOff:'下架',
                verifyOn:'審核通過',
                verifyOff:'未審核',
            }
        }
    },

}



// WEBPACK FOOTER //
// ./src/lang/tw.js